import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, of, pipe, Subject, combineLatest } from 'rxjs';
import { debounceTime, first, map, startWith, takeUntil, tap } from 'rxjs/operators';
// import { Cart } from '../../cart';
import { CartService } from '../../cart.service';
import { Currencies, CurrencyConverterService } from '../../../services/currency-converter.service';
import { Payment, Transaction } from '../../payment';
import { PaymentService } from '../../services/payment.service';
import { DealService } from '../../services/deal.service';
import { CombineLatestOperator } from 'rxjs/internal/observable/combineLatest';
import { Store } from '@ngrx/store';
import { CartState } from '../../state/cart.reducers';

import * as CartSelectors from '../../state/cart.selectors';

@Component({
   selector: 'app-payment',
   templateUrl: './payment.component.html',
   styleUrls: ['./payment.component.css'],
})
export class PaymentComponent implements OnInit, OnDestroy {
   terminator$: Subject<boolean> = new Subject();

   paymentTypes$: Observable<Object>;
   paymentTypesNames: string[];

   currencies: Currencies;
   paymentForm: FormGroup = this.fb.group({
      cartTotal: [null, Validators.required],
      // shipment: [0],
      // shipmentService: [0],
      // giftDiscount: [0],
      // cashierDiscount: [0],
      grandTotal: [null, Validators.required],
      paymentValue: [null, Validators.required],
      remainingValue: [null, Validators.required],
      activeDiscount: [null, [Validators.required, Validators.max(0.03)]],
      transactions: this.fb.array([
         // this.fb.group({
         //    paymentNo: [1],
         //    type: [''],
         //    amount: [],
         //    transValue: [0],
         //    commission: [],
         // })
      ]),
      additions: this.fb.array([]),
   });

   lastPaymentType: string;
   paymentTypes: object;

   activePayment$: Observable<Payment> = this.ps.activePayment$;

   // activeCart$: Observable<Cart>;
   cartTotal$: Observable<number>;

   showShipment = false;
   showShipmentService = false;
   showGiftDiscount = false;
   showCashierDiscount = false;

   get cartTotal() {
      return this.paymentForm.get('cartTotal') as FormControl;
   }

   get grandTotal() {
      return this.paymentForm.get('grandTotal') as FormControl;
   }

   get paymentValue() {
      return this.paymentForm.get('paymentValue') as FormControl;
   }

   get remainingValue() {
      return this.paymentForm.get('remainingValue') as FormControl;
   }

   get activeDiscount() {
      return this.paymentForm.get('activeDiscount') as FormControl;
   }

   get transactions() {
      return this.paymentForm.get('transactions') as FormArray;
   }

   get additions() {
      return this.paymentForm.get('additions') as FormArray;
   }

   constructor(
      private fb: FormBuilder,
      private currSrv: CurrencyConverterService,
      private ps: PaymentService,
      private cs: CartService,
      private ds: DealService,
      private store: Store<CartState>
   ) {}

   ngOnInit(): void {
      this.ps.getPaymentTypes();
      this.paymentTypes$ = this.ps.paymentTypes$;
      // console.log(this.paymentTypes);
      this.convertPaymentTypesToArr();

      this.activePayment$ = this.ps.activePayment$;

      this.getStoredTransactions();

      this.updateCartTotal();

      this.activePayment$.pipe().subscribe((val) => {
         this.paymentValue.setValue(val.totalTransactionValue);
         this.remainingValue.setValue(val.remainingValue);
         this.activeDiscount.setValue(val.activeDiscount);
         this.grandTotal.setValue(val.grandTotal);
      });

      this.paymentTypes$.subscribe((val) => (this.paymentTypes = val));
   }

   ngOnDestroy() {
      this.terminator$.next(true);
   }

   // used
   getStoredTransactions() {
      const paymentsSubscription$ = this.activePayment$
         .pipe(
            first(),
            tap((val) =>
               val.transactions.forEach((trans, i) => {
                  console.log('fetching stored transaction ', i);
                  const type = trans.type;
                  const amount = trans.amount.toString();
                  const value = trans.transValue;
                  console.log(type, ' ', amount, ' ', value);
                  this.addTransaction(type, amount, value);
               })
            ),
            tap((val) =>
               val.additions.forEach((adt, j) => {
                  console.log('fetching stored addition ', j);
                  const discount = adt.discount;
                  const name = adt.name;
                  const amount = adt.amount;
                  this.addAddition(name, amount, discount);
               })
            )
         )
         .subscribe();

      if (this.transactions.length === 0) {
         this.addTransaction();
      }
      paymentsSubscription$.unsubscribe();
      console.log('paymentsSubscription unsubscribed');
   }

   // used
   updateCartTotal() {
      // this.activeCart$ = this.cs.activeCart$;
      this.store.select(CartSelectors.cartProps).pipe(

            tap((val) => {
               this.cartTotal.setValue(val.cartGrandTotal, { emitEvent: true });
            }),
            tap(() => this.ps.changePayment(this.paymentForm.value))
         )
         .subscribe();
   }

   addAddition(name: string, startValue: number, discount: boolean): void {
      this.additions.push(this.buildAddition(name, startValue, discount));
      this.ps.changePayment(this.paymentForm.value);
      this.additions
         .at(this.additions.length - 1)
         .valueChanges.pipe(
            debounceTime(1000),
            tap((val) => {
               console.log('this additionalCost changed at : ', val.name);
               this.ps.changePayment(this.paymentForm.value);
            }),
            takeUntil(this.terminator$)
         )
         .subscribe();
   }

   buildAddition(name: string, startValue: number, discount: boolean): FormGroup {
      return this.fb.group({
         discount: [discount],
         name: [name],
         amount: [startValue],
      });
   }

   // used
   buildTransaction(type, amount, value): FormGroup {
      const index = this.transactions.length + 1;
      return this.fb.group({
         paymentNo: [index],
         type: [type],
         amount: [amount],
         transValue: [value],
         commission: [],
      });
   }

   // used
   addTransaction(type = 'Nakit TL', amount = '', value = 0): void {
      this.transactions.push(this.buildTransaction(type, amount, value));
      this.transactions
         .at(this.transactions.length - 1)
         .valueChanges.pipe(
            debounceTime(1000),
            tap((val) => {
               const paymentType = this.transactions.at(val.paymentNo - 1).get('type').value;
               console.log('paymentType: ', paymentType);
               const paymentAmount = this.transactions.at(val.paymentNo - 1).get('amount').value;
               console.log('paymentAmount: ', paymentAmount);
               this.transactions
                  .at(val.paymentNo - 1)
                  .get('transValue')
                  .setValue(this.paymentTypes[paymentType].tlValue * paymentAmount, {
                     // .setValue(this.paymentTypes$.pipe(pluck(paymentType, 'tlValue'), takeUntil(this.terminator$)).subscribe(val => val* paymentAmount) , {
                     onlySelf: false,
                     emitEvent: false,
                  });
            }),
            tap(() => {
               console.log('ps.changePayment should run');
               this.ps.changePayment(this.paymentForm.value);
            }),
            takeUntil(this.terminator$)
         )
         .subscribe();
   }

   // used
   removeTransaction(index: number): void {
      console.log('remove from index: ', index);
      // this.transactions.at(index).patchValue({ amount: 0, transValue: 0});
      // this.transactions.at(index).disable();
      this.transactions.removeAt(index);
      for (let i = index; i < this.transactions.length; i++) {
         this.transactions.at(i).patchValue({ paymentNo: i + 1 });
      }

      // this.cs.changePayment(this.paymentForm.value);

      // this.addPayment();
   }

   resetForm() {
      this.additions.clear();
      this.transactions.clear();

      this.addTransaction();

      this.ps.changePayment(this.paymentForm.value);
   }


   // used
   convertPaymentTypesToArr() {
      this.paymentTypes$.pipe(takeUntil(this.terminator$)).subscribe((val) => {
         let paymentTypesArr = [];
         for (let type in val) {
            paymentTypesArr.push(type);
         }
         console.log(paymentTypesArr);
         this.paymentTypesNames = paymentTypesArr;
      });
   }


}
